export const getCurrentRoute = (state) => state.location.type;
export const getPayload = (state) => state.location.payload;
export const getCurrentPathname = (state) => state.location.pathname;
